import { axiosPrivate } from '@/api/axios';
import { useEffect } from 'react';
import useRefreshToken from './useRefreshToken';
import useAuth from './useAuth';
import Api from '@/api/api';
import { getFingerprint } from '@/services/fingerprintService';

const useAxiosPrivate = () => {
  const refresh = useRefreshToken();
  const auth = useAuth();

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      async (config: any) => {
        // Añadir token de autorización si no está presente
        if (!config.headers['Authorization']) {
          config.headers['Authorization'] = auth?.user?.accessToken;
        }
        
        // Añadir fingerprint a todas las peticiones
        try {
          const fingerprint = await getFingerprint();
          config.headers['x-device-fp'] = fingerprint;
        } catch (error) {
          console.error('Error al aplicar fingerprint en useAxiosPrivate:', error);
        }
        
        return config;
      }, (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 403 && !prevRequest?.sent) {
          prevRequest.sent = true;
          const userData = await refresh();
          prevRequest.headers['Authorization'] = userData.id;
          return axiosPrivate(prevRequest);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    }
  }, [auth?.user, refresh]);

  // console.log('[use api user]', auth?.user);
  return new Api(axiosPrivate, auth?.user?.user);
}

export default useAxiosPrivate;
